<div class="confirmation-component">
  <app-attendee-header
    class="confirmation-component__header"
  ></app-attendee-header>
  <main id="main-content" class="confirmation-component__content pb-6">
    <section
      class="confirmation-component__left-panel"
      *ngIf="!isLoading && items"
    >
      <img
        class="confirmation-component__icon"
        src="assets/checkout/confirmation/circled-check.svg"
        [alt]="'checkout.confirmation.success_alt' | translate"
      />
      <h1 class="confirmation-component__title">
        {{ 'checkout.confirmation.checkout_validation' | translate }}
      </h1>
      <p
        *ngIf="!isActivityEvent"
        class="confirmation-component__text mb-4"
        [innerHTML]="'checkout.confirmation.text' | translate"
      ></p>
      <p
        *ngIf="isActivityEvent"
        class="confirmation-component__text mb-4"
        [innerHTML]="'checkout.confirmation.event' | translate"
      ></p>
      <a
        *ngIf="!isActivityEvent"
        app-vtmn-play-button
        [routerLink]="redirectPath | localize"
        [size]="vtmnPlayButtonSize.MEDIUM"
        [shape]="vtmnPlayButtonShape.SQUARED"
        data-test="finish-subscription"
      >
        {{ 'checkout.confirmation.continue' | translate }}
      </a>
    </section>
    <section
      class="confirmation-component__right-panel"
      [ngClass]="
        activityEligible ? 'confirmation-component__right-panel--full' : ''
      "
    >
      <div
        *ngIf="
          (isLoading && activityEligible) || (isLoading && isActivityEvent)
        "
        class="w-[5rem] h-[5rem] mx-auto overflow-hidden"
      >
        <div class="spinner"></div>
      </div>
      <div
        *ngIf="hasError && !isLoading && (activityEligible || isActivityEvent)"
        class="flex flex-col justify-center items-center"
      >
        <img src="./assets/errors/invalid.svg" alt="" class="w-[200px] mb-4" />
        <p class="mb-4 text-center">{{ hasError }}</p>
      </div>
      <div
        *ngIf="!hasError && !isLoading && (activityEligible || isActivityEvent)"
        class="my-4"
      >
        <h1 class="vtmn-title-4 mt-2 text-center">{{ title }}</h1>
        <div class="w-[90%] mx-auto" [innerHTML]="sanitizedSvg"></div>
        <div class="flex flex-col justify-between">
          <button
            app-vtmn-play-button
            [size]="vtmnPlayButtonSize.MEDIUM"
            [shape]="vtmnPlayButtonShape.SQUARED"
            class="w-full mb-2"
            [attr.data-disabled]="hasError"
            target="_blank"
            *ngIf="bookingItemId && isMobileDevice && isAppleDevice"
            (click)="downloadWalletPass(bookingItemId)"
          >
            {{ 'checkout.confirmation.qrcode.waller' | translate }}
          </button>
          <a
            app-vtmn-play-button
            [size]="vtmnPlayButtonSize.MEDIUM"
            [shape]="vtmnPlayButtonShape.SQUARED"
            [href]="pdfUrl"
            class="w-full"
            [attr.data-disabled]="hasError"
            target="_blank"
            *ngIf="pdfUrl"
          >
            {{ 'checkout.confirmation.qrcode.pdf' | translate }}
          </a>
        </div>
      </div>
      <ng-container *ngIf="items?.length > 0">
        <app-loyalty-points-card
          class="confirmation-component__loyalty"
          *appIsEnabled="toggleNameEnum.ActivityLoyaltyPoints"
          [link]="decatClubUrl"
          [ecological]="items[0]?.activity?.ecological"
        ></app-loyalty-points-card>
        <div class="confirmation-component__right-panel-add-to-calendar">
          <h2 class="add-to-calendar__title">
            {{ 'checkout.confirmation.add_calendar' | translate }}
          </h2>
          <div class="add-to-calendar__button-row" *ngFor="let item of items">
            <button
              type="button"
              class="add-to-calendar__button"
              *ngFor="let media of mediaList"
              (click)="redirect(media, item)"
            >
              <img
                class="add-to-calendar__image"
                [src]="getMediaImageSrc(media)"
                [alt]="getMediaTitle(media)"
              />
              <span class="add-to-calendar__button-text">
                {{ getMediaTitle(media) }}
              </span>
            </button>
          </div>
        </div>
      </ng-container>
    </section>
  </main>
</div>
